import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import {
    Alert,
    Avatar,
    Box,
    Card,
    CardContent,
    TextField,
    Drawer,
    IconButton,
    Typography,
    Fade,
    Button,
    Grid,
    MenuItem,
    Menu,
    Checkbox,
    FormControlLabel,
    Collapse,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    LinearProgress
} from '@mui/material';
import { IconPlus, IconBell, IconFilter, IconFilterOff, IconUsers } from '@tabler/icons';
import NovaConversaDialog from './NovaConversaDialog';
// import OutlinedInput from '@mui/material/OutlinedInput';
import axios from 'axios';
import { apiUrl, token } from '../../../../api';
import api from '../../../services/api';
import { subscribeToPush, updateViewingConversation } from '../../../../utils/pushNotifications';
// import { use } from 'react';
// import { IconPlus, IconArrowRight } from '@tabler/icons';

import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SendIcon from '@mui/icons-material/Send';
import MicIcon from '@mui/icons-material/Mic';

// import EmojiPicker from 'emoji-picker-react';

// material-ui
import { makeStyles } from '@mui/styles';
import useTheme from '@mui/material/styles/useTheme';

import Badge from '@mui/material/Badge';
// import MailIcon from '@mui/icons-material/Mail';

//? IMPORT TABS
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

//? IMPORT DOS ARQUIVOS DE CONVERSAS
import ConversasGeral from './ConversasGeral';
import JanelaConversa from './JanelaConversa';

//? Negócios
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DealConversationCard from './DealConversationCard';

// style constant
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex'
    },
    appBar: {
        backgroundColor: '#2B2C4A', //theme.palette.background.default,
        zIndex: theme.zIndex.drawer + 1,
        height: 48,
        transition: theme.transitions.create(['top'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    conversationBar: {
        background: '#161818',
        color: '#e60000'
    },
    toolbar: {
        minHeight: 48
    },
    appBarWidth: {
        transition: theme.transitions.create('width'),
        backgroundColor: theme.palette.background.default
    },
    content: {
        ...theme.typography.mainContent,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            // marginLeft: -(drawerWidth - 20),
            // width: `calc(100% - ${drawerWidth}px)`
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px',
            // width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            // width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px',
            marginRight: '10px'
        }
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px'
        }
    }
}));

const getBoardContainerSx = (isDark) => ({
    position: 'relative',
    mt: 2,
    p: 2,
    borderRadius: '30px',
    overflow: 'hidden',
    border: isDark ? '1px solid rgba(108,220,255,0.16)' : '1px solid rgba(0,130,220,0.18)',
    background: isDark
        ? `
        radial-gradient(circle at 50% 0%, rgba(0,180,255,0.10), transparent 20%),
        radial-gradient(circle at 15% 100%, rgba(0,140,255,0.08), transparent 18%),
        linear-gradient(180deg, rgba(5,12,22,0.95) 0%, rgba(3,7,14,0.98) 100%)
    `
        : `
        radial-gradient(circle at 50% 0%, rgba(0,150,255,0.08), transparent 20%),
        radial-gradient(circle at 15% 100%, rgba(0,120,255,0.06), transparent 18%),
        linear-gradient(180deg, rgba(255,255,255,0.92) 0%, rgba(233,246,255,0.96) 100%)
    `,
    boxShadow: isDark
        ? '0 0 50px rgba(0,170,255,0.08), inset 0 0 70px rgba(43,170,255,0.035), inset 0 1px 0 rgba(255,255,255,0.04)'
        : '0 0 30px rgba(0,140,255,0.10), inset 0 0 40px rgba(0,140,255,0.03), inset 0 1px 0 rgba(255,255,255,0.7)'
});

const getFilterPanelSx = (isDark) => ({
    mt: 2,
    p: 2.5,
    borderRadius: '24px',
    border: isDark ? '1px solid rgba(110,220,255,0.14)' : '1px solid rgba(0,120,220,0.16)',
    background: isDark
        ? 'linear-gradient(180deg, rgba(10,20,33,0.92), rgba(5,10,18,0.96))'
        : 'linear-gradient(180deg, rgba(255,255,255,0.92), rgba(232,244,255,0.85))',
    backdropFilter: 'blur(14px)',
    boxShadow: isDark ? 'inset 0 0 25px rgba(95,220,255,0.03)' : 'inset 0 0 18px rgba(0,140,255,0.03)'
});

const getFilterFieldSx = (isDark) => ({
    '& .MuiOutlinedInput-root': {
        borderRadius: '14px',
        color: isDark ? '#fff' : 'rgba(8,35,60,0.92)',
        background: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(255,255,255,0.85)',
        '& fieldset': {
            borderColor: isDark ? 'rgba(110,220,255,0.15)' : 'rgba(0,120,220,0.18)'
        },
        '&:hover fieldset': {
            borderColor: isDark ? 'rgba(110,220,255,0.35)' : 'rgba(0,120,220,0.35)'
        },
        '&.Mui-focused fieldset': {
            borderColor: isDark ? '#6edcff' : '#0091ea'
        }
    },
    '& .MuiInputLabel-root': {
        color: isDark ? 'rgba(255,255,255,0.55)' : 'rgba(8,35,60,0.55)'
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: isDark ? '#7be9ff' : '#0091ea'
    }
});

const CANAIS_MENSAGEM = [
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'messenger', label: 'Messenger' },
    { value: 'chat_web', label: 'Chat Web' },
    { value: 'voice', label: 'Voz' },
    { value: 'email', label: 'E-mail' },
    { value: 'agent_workspace', label: 'Agente' },
    { value: 'custom', label: 'Customizada' }
];

const FILTROS_CHAT_INICIAIS = {
    canal: '',
    dataInicio: '',
    dataFim: '',
    apenasMeus: false,
    naoAbertos: false,
    assign: '',
    contatoCanal: '',
    nomeCliente: '',
    nomeOrganizacao: '',
    textoMensagem: ''
};

// Índice da aba (`value`) -> `state` da conversa no backend, nessa mesma
// ordem das abas renderizadas mais abaixo.
const STATE_TABS = ['in_bot', 'new', 'open', 'in_progress', 'pending', 'closed'];

// Quantas conversas carregar por aba de cada vez - com muitas conversas,
// trazer tudo de uma vez pras 6 abas deixava a tela pesada; agora só a
// aba ativa é buscada, paginada, com um botão "Carregar mais". 100 (não
// mais 30) - com uma conta de milhares de conversas e um filtro ativo
// (ex: "Atribuído"), 30 por página exigia clicar "Carregar mais" várias
// vezes só pra achar a próxima conversa que batia com o filtro.
const PAGE_SIZE = 100;

//?------------- TABS PARA TROCAR LATERALMENTE -----------------------
// Definidos no nível de módulo (fora do componente): se ficassem dentro de
// `Chats`, seriam recriados como um tipo de componente NOVO a cada
// re-render (o que acontece a cada 3s por causa do polling, entre outras
// causas) — React então desmonta e remonta TODO o conteúdo da aba a cada
// render, resetando o scroll da lista de conversas para o topo.
const StyledTabs = styled((props) => <Tabs {...props} TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }} />, {
    shouldForwardProp: (prop) => prop !== 'isDark'
})(({ isDark }) => ({
    '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent'
    },
    '& .MuiTabs-indicatorSpan': {
        maxWidth: 40,
        width: '100%',
        backgroundColor: isDark ? '#7be9ff' : '#0091ea',
        boxShadow: isDark ? '0 0 14px rgba(123,233,255,0.4)' : '0 0 10px rgba(0,145,234,0.35)'
    }
}));

const StyledTab = styled((props) => <Tab disableRipple {...props} />, { shouldForwardProp: (prop) => prop !== 'isDark' })(
    ({ theme, isDark }) => ({
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        marginRight: theme.spacing(1),
        color: isDark ? 'rgba(255,255,255,0.60)' : 'rgba(8,35,60,0.60)',
        '&.Mui-selected': {
            color: isDark ? 'rgba(255,255,255,0.95)' : 'rgba(8,35,60,0.92)'
        }
    })
);

function TabPanel(props) {
    const { children, value, index } = props;

    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
};

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`
    };
}
//?--------------- FIM TABS PARA TROCAR LATERALMENTE ------------------

const Chats = () => {
    // const [user, setUser] = useState('');

    const user = useSelector((state) => state.account.user);
    const role_user = useSelector((state) => state.account.user?.role || '');

    const classes = useStyles();

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [status, setStatus] = useState({ type: '', message: '' });

    //?NEGÓCIOS
    const [pipelines, setPipelines] = useState([]);
    const [pipelineId, setPipelineId] = useState(null);
    const [stages, setStages] = useState([]);
    const [dealsByStage, setDealsByStage] = useState({}); // { stageId: [deals] }
    const [selectedDeal, setSelectedDeal] = useState(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [openBox, setOpenBox] = useState(false);

    //?APP
    const [appId, setAppId] = useState();

    //? Deep-link: abrir uma conversa específica via ?id= na URL (ex: vindo da tela de Contatos)
    const location = useLocation();
    const history = useHistory();
    const didOpenConversationFromQuery = useRef(false);

    //? Nova conversa (iniciada pelo atendente por telefone)
    const [openNovaConversa, setOpenNovaConversa] = useState(false);

    //?CONVERSAS
    const [conversaSelecionada, setConversaSelecionada] = useState(null);
    // { [state]: Conversation[] } - só a aba ativa (`STATE_TABS[value]`)
    // efetivamente busca dados; as outras ficam com o que já foi
    // carregado da última vez que estiveram ativas (ou vazio).
    const [conversationsByState, setConversationsByState] = useState({});
    // { [state]: { total, unread, loadingMore } } - `total`/`unread` vêm
    // do endpoint de resumo (leve, cobre as 6 abas de uma vez, mesmo as
    // não carregadas); `loadingMore` é local, do botão "Carregar mais".
    const [convMeta, setConvMeta] = useState({});
    // Ref (não state) - `pegar_conversas` roda dentro de um setInterval
    // cujo closure foi capturado na hora que o efeito rodou; um state
    // comum ficaria desatualizado ali, a ref sempre reflete o valor mais
    // recente de quantas conversas já estão carregadas em cada aba.
    const convLoadedCountRef = useRef({});
    // Qual `?assign=` estava em vigor na última busca de cada aba - usado
    // só pra saber quando ZERAR `convLoadedCountRef` (troca de filtro,
    // não só um refresh/poll do mesmo filtro de sempre).
    const convAssignFilterRef = useRef({});
    const [selectedConversation, setSelectedConversation] = useState(null);
    // Sempre reflete o id da conversa selecionada mais recente - usado pra
    // descartar respostas de mensagens que chegam atrasadas de uma conversa
    // que já não é mais a selecionada (evita mostrar o chat errado).
    const selectedConversationIdRef = useRef(null);

    // Seleção em lote (checkbox do lado de cada conversa + botão "Ações") -
    // pensado pro caso de disparo em massa (campanha pra centenas de
    // clientes): em vez de abrir e clicar "Finalizar" conversa por
    // conversa, seleciona todas de uma vez e aplica a ação.
    const [selectionMode, setSelectionMode] = useState(false);
    const [selectedConversationIds, setSelectedConversationIds] = useState(new Set());
    const [actionsMenuAnchor, setActionsMenuAnchor] = useState(null);
    const [bulkActionLoading, setBulkActionLoading] = useState(false);

    const [integration_id, setIntegrationId] = useState(null);

    //?MENSAGENS
    const [messages, setMessages] = useState([]);
    const [messagesLoading, setMessagesLoading] = useState(false);
    const [inputMessage, setInputMessage] = useState('');
    // `message_list_create` (GET) agora só traz a janela mais recente por
    // padrão (ver backend) - esses dois controlam o botão "Carregar
    // mensagens anteriores" que busca mais história sob demanda.
    const [hasMoreOlderMessages, setHasMoreOlderMessages] = useState(false);
    const [loadingOlderMessages, setLoadingOlderMessages] = useState(false);

    //? TABS
    const [value, setValue] = React.useState(0);
    const [value2, setValue2] = React.useState(0);

    //? LISTAS PERSONALIZADAS (etiquetas, tipo Labels do WhatsApp)
    const [customLists, setCustomLists] = useState([]);
    const [selectedListId, setSelectedListId] = useState(null);
    const [listConversations, setListConversations] = useState([]);
    const [createListDialogOpen, setCreateListDialogOpen] = useState(false);
    const [newListName, setNewListName] = useState('');
    const [newListColor, setNewListColor] = useState('#1976d2');

    //? EQUIPES - filtro por equipe (botão "Equipes" ao lado de "Filtros").
    // O backend já restringe sozinho quem não é admin/manager a só ver as
    // próprias equipes (ou conversa sem equipe nenhuma) mesmo sem usar
    // esse filtro - ele serve pra ESCOLHER entre as que a pessoa pode ver
    // (útil quando pertence a mais de uma), ou pro admin restringir a
    // visão a uma equipe específica.
    const [equipesFiltro, setEquipesFiltro] = useState([]);
    const [selectedTeamFilter, setSelectedTeamFilter] = useState('');
    const [teamMenuAnchor, setTeamMenuAnchor] = useState(null);

    //? FILTROS
    const podeFiltrarPorQualquerAtribuido = role_user === 'admin' || role_user === 'manager';
    const [teamUsers, setTeamUsers] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [filtros, setFiltros] = useState(FILTROS_CHAT_INICIAIS);

    // Lista de usuários pro filtro "Atribuído" (só admin/manager podem
    // filtrar pelo atribuído de qualquer pessoa - mesma regra já usada em
    // Negócios, `PipelineMain.js`).
    useEffect(() => {
        if (!podeFiltrarPorQualquerAtribuido) return;

        const carregarUsuarios = async () => {
            try {
                const response = await api.get('users/');
                setTeamUsers(response.data?.users || response.data || []);
            } catch (error) {
                console.error(error);
            }
        };

        carregarUsuarios();
    }, [podeFiltrarPorQualquerAtribuido]);

    // Busca por nome do contato em TODAS as etapas de uma vez (No Bot/
    // Novas/Abertas/Em andamento/Pendente/Fechada) - antes, `filtros.contatoCanal`
    // só filtrava as conversas JÁ carregadas da aba aberta no momento,
    // obrigando o atendente a clicar em cada uma das 6 abas pra achar a
    // conversa. Com um termo digitado, troca as abas por uma lista única
    // combinando o resultado de todas (`buscaGlobalResultados` !== null
    // é o sinal pro JSX usar essa lista em vez de `conversationsByState`).
    // Debounce de 400ms - sem isso, cada tecla digitada disparava uma
    // chamada nova pro backend.
    const [buscaGlobalResultados, setBuscaGlobalResultados] = useState(null);
    const [buscaGlobalLoading, setBuscaGlobalLoading] = useState(false);

    useEffect(() => {
        const termoContato = filtros.contatoCanal.trim();
        // Palavra(s) que o atendente lembra de ter trocado na conversa, mas
        // não lembra o nome do cliente - busca no CONTEÚDO das mensagens em
        // vez do nome do contato (`termoContato` acima).
        const termoMensagem = filtros.textoMensagem.trim();
        if ((!termoContato && !termoMensagem) || !appId) {
            setBuscaGlobalResultados(null);
            return undefined;
        }

        setBuscaGlobalLoading(true);
        const timeoutId = setTimeout(async () => {
            try {
                const params = {};
                if (termoContato) params.search = termoContato;
                if (termoMensagem) params.message_search = termoMensagem;
                const response = await api.get(`v1/apps/${appId}/conversations/`, { params });
                setBuscaGlobalResultados(response.data?.conversations || []);
            } catch (error) {
                console.error('Erro ao buscar conversas em todas as etapas:', error);
                setBuscaGlobalResultados([]);
            } finally {
                setBuscaGlobalLoading(false);
            }
        }, 400);

        return () => clearTimeout(timeoutId);
    }, [filtros.contatoCanal, filtros.textoMensagem, appId]);

    const limparFiltros = () => setFiltros(FILTROS_CHAT_INICIAIS);

    const filtrosAtivosCount = Object.values(filtros).filter((valor) => (typeof valor === 'boolean' ? valor : valor !== '')).length;

    // Valor efetivo do filtro "Atribuído" mandado pro backend (`?assign=`)
    // - "Atribuídos a mim" (qualquer papel) tem prioridade sobre o
    // dropdown "Atribuído" (só admin/manager, `podeFiltrarPorQualquerAtribuido`)
    // quando os dois estiverem ativos ao mesmo tempo.
    const assignQueryValue = filtros.apenasMeus ? user?.id || '' : podeFiltrarPorQualquerAtribuido ? filtros.assign : '';

    const filtrarConversas = (lista) => {
        if (!lista) return [];

        // "Atribuídos a mim" não existe como campo direto na conversa - o
        // responsável é sempre do NEGÓCIO ativo dela (mesma lógica usada no
        // Kanban), então cruza conversation.deal com os deals já carregados
        // pelo loadPipeline/pegar_negocios (dealsByStage).
        const dealsById = {};
        Object.values(dealsByStage).forEach((arr) => arr.forEach((d) => (dealsById[d.id] = d)));

        return lista.filter((conversa) => {
            if (filtros.canal && conversa.type !== filtros.canal) return false;

            if (filtros.dataInicio) {
                const inicio = new Date(`${filtros.dataInicio}T00:00:00`);
                if (!conversa.createdAt || new Date(conversa.createdAt) < inicio) return false;
            }

            if (filtros.dataFim) {
                const fim = new Date(`${filtros.dataFim}T23:59:59`);
                if (!conversa.createdAt || new Date(conversa.createdAt) > fim) return false;
            }

            // "Atribuído a mim"/"Atribuído" (`apenasMeus`/`assign`) NÃO são
            // mais filtrados aqui - foram pro backend (`?assign=`,
            // `conversation_list_create`), que já reconstrói a busca/
            // paginação em cima do conjunto CERTO desde o início. Filtrar
            // aqui também, por cima, dependia de `dealsById` (cache do
            // Kanban) ter o deal de TODA conversa já carregada - uma
            // conversa cujo deal não estivesse nesse cache (stage ainda
            // não aberta no Kanban) sumia da lista mesmo o backend tendo
            // mandado ela certinho.
            if (filtros.naoAbertos && conversa.type_author_last_message !== 'user') return false;

            if (filtros.contatoCanal) {
                const nomeContato = (conversa.displayName || '').toLowerCase();
                if (!nomeContato.includes(filtros.contatoCanal.toLowerCase())) return false;
            }

            if (filtros.nomeCliente) {
                const deal = conversa.deal ? dealsById[conversa.deal] : null;
                const nomeCliente = `${deal?.user_detail?.first_name || ''} ${deal?.user_detail?.last_name || ''}`.toLowerCase();
                if (!nomeCliente.includes(filtros.nomeCliente.toLowerCase())) return false;
            }

            if (filtros.nomeOrganizacao) {
                const deal = conversa.deal ? dealsById[conversa.deal] : null;
                const nomeOrg = (deal?.organization_detail?.name || '').toLowerCase();
                if (!nomeOrg.includes(filtros.nomeOrganizacao.toLowerCase())) return false;
            }

            return true;
        });
    };

    // Botão "Carregar mais" de uma aba - só o mostra quando ainda existem
    // conversas daquele `state` além das já carregadas (`convMeta[state].total`
    // vem do endpoint de resumo, independente de quantas páginas já foram
    // buscadas).
    const renderCarregarMaisConversas = (state) => {
        const meta = convMeta[state] || {};
        const carregadas = conversationsByState[state]?.length || 0;
        if (carregadas >= (meta.total || 0)) return null;

        return (
            <Button
                fullWidth
                size="small"
                onClick={handleLoadMoreConversas}
                disabled={meta.loadingMore}
                sx={{ mt: 1, borderRadius: '14px', textTransform: 'none' }}
            >
                {meta.loadingMore ? 'Carregando...' : `Carregar mais (${meta.total - carregadas} restantes)`}
            </Button>
        );
    };

    const pegar_app_padrao = async () => {
        // console.log(`pegar_app_padrao - entrou`);
        try {
            const response = await api.get('v1/apps/default/');
            const data = response.data;
            // console.log(`pegar_app_padrao - achou`);

            if (!data?.app?.id) {
                console.warn('App ID não veio da API');
                return;
            }

            setAppId(data.app.id);
        } catch (error) {
            console.error('Erro ao buscar app padrão:', error);
        }
    };

    //? ---------- Pegar integration ---------------------
    const pegar_integration = async (conversation_id) => {
        // console.log(`pegar_integration - entrou`);
        try {
            if (!appId) return;
            const response = await api.get(`v1/apps/${appId}/conversations/${conversation_id}/list_integration/`);
            if (response.data) {
                console.log(`pegar_integration - achou  integration: ${JSON.stringify(response.data.integration)}`);
                setIntegrationId(response.data.integration.id);
                // const integrations = response.data.integrations;
            }
        } catch (error) {
            console.error('Erro ao buscar integrações:', error);
        }
    };

    //? ------------ USE EFFECTS ------------------------
    useEffect(() => {
        // console.log(`pegar_app_padrao useeffects - entrou`);
        pegar_app_padrao();
    }, []);

    //? Notificações push: tenta assinar automaticamente assim que sabemos o
    //? app - funciona no Android/Chrome mesmo sem toque do usuário. O iOS
    //? (Safari) EXIGE que o pedido de permissão aconteça dentro de um toque
    //? direto do usuário, senão ele ignora silenciosamente - por isso também
    //? mostramos um botão explícito (handleAtivarNotificacoes) quando a
    //? permissão ainda não foi decidida.
    const [pushPermission, setPushPermission] = useState(typeof Notification !== 'undefined' ? Notification.permission : 'unsupported');

    useEffect(() => {
        if (!appId) return;
        subscribeToPush(appId).finally(() => {
            if (typeof Notification !== 'undefined') setPushPermission(Notification.permission);
        });
    }, [appId]);

    const handleAtivarNotificacoes = async () => {
        await subscribeToPush(appId);
        if (typeof Notification !== 'undefined') setPushPermission(Notification.permission);
    };

    //? Deep-link: se a URL vier com ?id=<conversationId> (ex: botão "Abrir Conversa"
    //? da tela de Contatos), busca essa conversa e já abre o drawer nela.
    useEffect(() => {
        if (!appId || didOpenConversationFromQuery.current) return;

        const params = new URLSearchParams(location.search);
        const conversationId = params.get('id');
        if (!conversationId) return;

        didOpenConversationFromQuery.current = true;

        (async () => {
            try {
                const response = await api.get(`v1/apps/${appId}/conversations/${conversationId}/`);
                await handleOpenConversation(response.data.conversation);
            } catch (error) {
                console.error('Erro ao abrir conversa via link:', error);
            } finally {
                history.replace('/dashboard/chats');
            }
        })();
    }, [appId, location.search]);

    useEffect(() => {
        // if (!localStorage.getItem('access_token')) return;
        if (!appId) return;
        loadPipeline();
        loadCustomLists();
        loadEquipesFiltro();
    }, [appId]);

    // Busca a aba ativa (e o resumo de todas) sempre que o app fica pronto,
    // o usuário troca de aba, OU muda o filtro "Atribuído"/"Atribuídos a
    // mim" (`assignQueryValue`) - esse filtro passou a ser aplicado no
    // BACKEND (ver `conversation_list_create`), então mudar de valor
    // precisa refazer a busca (os outros filtros continuam só client-side,
    // reaplicados a cada render por `filtrarConversas`, sem precisar de
    // fetch novo).
    useEffect(() => {
        if (!appId) return;
        pegar_conversas();
    }, [appId, value, selectedTeamFilter, assignQueryValue]);

    useEffect(() => {
        if (!appId) return;

        const interval = setInterval(() => {
            pegar_conversas_poll();

            if (selectedConversation) {
                // marcar_conversa_como_lida(selectedConversation.id);
            }

            loadPipeline();

            if (selectedListId) {
                loadListConversations(selectedListId);
            }
        }, 3000);

        return () => clearInterval(interval);
    }, [appId, selectedConversation, selectedListId, value, assignQueryValue]);

    useEffect(() => {
        if (!appId) return;

        if (!selectedConversation || !appId) return;

        // pegar_integration(selectedConversation.id);

        pegar_mensagens_conversa();

        const interval = setInterval(() => {
            // `merge: true` - o poll busca só a janela mais recente (o
            // backend agora pagina, ver `message_list_create`), nunca a
            // conversa inteira; sem mesclar, um `setMessages` substituindo
            // o array inteiro apagaria qualquer página mais antiga já
            // carregada via "Carregar mensagens anteriores".
            pegar_mensagens_conversa({ merge: true });

            if (!selectedConversation) return;

            // marcar_conversa_como_lida(selectedConversation.id);
        }, 3000);

        return () => clearInterval(interval);
    }, [selectedConversation?.id, appId]);

    //? -------------------------------------------

    const loadEquipesFiltro = async () => {
        if (!appId) return;
        try {
            const response = await api.get(`v1/apps/${appId}/teams/`);
            setEquipesFiltro(response.data?.teams || []);
        } catch (error) {
            console.error('Erro ao carregar equipes', error);
        }
    };

    const handleSelectTeamFilter = (teamId) => {
        setSelectedTeamFilter(teamId || '');
        setTeamMenuAnchor(null);
    };

    const loadCustomLists = async () => {
        if (!appId) return;
        try {
            const response = await api.get(`v1/apps/${appId}/conversation_lists/`);
            setCustomLists(response.data || []);
        } catch (error) {
            console.error('Erro ao carregar listas personalizadas', error);
        }
    };

    const loadListConversations = async (listId) => {
        if (!appId || !listId) return;
        try {
            const response = await api.get(`v1/apps/${appId}/conversation_lists/${listId}/conversations/`);
            setListConversations(response.data.conversations || []);
        } catch (error) {
            console.error('Erro ao carregar conversas da lista', error);
        }
    };

    const handleSelectList = (listId) => {
        setSelectedListId(listId);
        loadListConversations(listId);
    };

    const handleClearSelectedList = () => {
        setSelectedListId(null);
        setListConversations([]);
    };

    const handleCreateList = async () => {
        const name = newListName.trim();
        if (!name || !appId) return;
        try {
            await api.post(`v1/apps/${appId}/conversation_lists/`, { name, color: newListColor });
            setNewListName('');
            setCreateListDialogOpen(false);
            loadCustomLists();
        } catch (error) {
            console.error('Erro ao criar lista', error);
        }
    };

    const handleDeleteList = async (listId, listName) => {
        if (!appId) return;
        const confirmar = window.confirm(`Apagar a lista "${listName}"? As conversas não são apagadas, só deixam de fazer parte dela.`);
        if (!confirmar) return;
        try {
            await api.delete(`v1/apps/${appId}/conversation_lists/${listId}/`);
            if (selectedListId === listId) {
                handleClearSelectedList();
            }
            loadCustomLists();
        } catch (error) {
            console.error('Erro ao apagar lista', error);
        }
    };

    // Busca, numa passada só: (1) o resumo por aba - total + não lidas,
    // leve, cobre TODAS as abas mesmo as que não estão carregadas, é o
    // que alimenta os badges; (2) a lista paginada só da aba ATIVA
    // (`STATE_TABS[value]`) - as outras abas mantêm o que já tinham
    // carregado da última vez que estiveram ativas. Refaz a busca da aba
    // ativa com o tanto que já estava carregado (via `convLoadedCountRef`,
    // não um state comum por causa do closure do polling) pra um refresh
    // periódico não "encolher" uma aba que o usuário já tinha expandido
    // com "Carregar mais".
    const pegar_conversas = async () => {
        if (!appId) return;

        try {
            const teamQuery = selectedTeamFilter ? `&team=${selectedTeamFilter}` : '';
            const assignQuery = assignQueryValue ? `&assign=${assignQueryValue}` : '';
            const resSummary = await api.get(
                `v1/apps/${appId}/conversations/summary/${selectedTeamFilter ? `?team=${selectedTeamFilter}` : ''}`
            );
            const counts = resSummary.data?.counts || {};
            setConvMeta((prev) => {
                const atualizado = { ...prev };
                STATE_TABS.forEach((state) => {
                    atualizado[state] = {
                        ...(atualizado[state] || {}),
                        total: counts[state]?.total || 0,
                        unread: counts[state]?.unread || 0
                    };
                });
                return atualizado;
            });

            const activeState = STATE_TABS[value];
            // Quando o filtro "Atribuído" está ativo, zera a contagem já
            // carregada antes de montar o `limit` - senão, trocar de uma
            // pessoa atribuída pra outra (ou ligar/desligar o filtro)
            // herdava o tanto carregado da busca ANTERIOR (ex: 300, de uma
            // sessão sem filtro) e pedia 300 de cara na busca filtrada,
            // em vez de começar do primeiro lote (PAGE_SIZE).
            if (assignQueryValue !== convAssignFilterRef.current[activeState]) {
                convLoadedCountRef.current = { ...convLoadedCountRef.current, [activeState]: 0 };
                convAssignFilterRef.current = { ...convAssignFilterRef.current, [activeState]: assignQueryValue };
            }
            const limit = Math.max(convLoadedCountRef.current[activeState] || PAGE_SIZE, PAGE_SIZE);
            const resList = await api.get(
                `v1/apps/${appId}/conversations/?state=${activeState}&limit=${limit}&offset=0${teamQuery}${assignQuery}`
            );
            const lista = resList.data?.conversations || [];
            convLoadedCountRef.current = { ...convLoadedCountRef.current, [activeState]: lista.length };
            setConversationsByState((prev) => ({ ...prev, [activeState]: lista }));
            // `total` filtrado (reflete o `?assign=` acima, quando ativo) -
            // sobrescreve o total BRUTO que o `/summary/` acabou de setar
            // pra essa aba específica, senão o botão "Carregar mais" fica
            // comparando contra o total errado (da aba inteira, não do
            // filtro) e nunca some mesmo sem mais nada a carregar.
            if (typeof resList.data?.total === 'number') {
                setConvMeta((prev) => ({ ...prev, [activeState]: { ...(prev[activeState] || {}), total: resList.data.total } }));
            }

            setStatus({ type: '', message: '' });
        } catch (error) {
            console.error(error);
        }
    };

    // Refresh leve usado SÓ pelo polling de 3s (nunca no mount/troca de
    // aba/filtro, que continua usando `pegar_conversas` acima) - NUNCA
    // pede de volta "tudo que já foi carregado" (`convLoadedCountRef`).
    // Isso é de propósito: era exatamente esse `limit` crescendo a cada
    // "Carregar mais" que causava o bug do botão "voltando sozinho" -
    // assim que o `limit` pedido passava do teto do backend, a resposta
    // vinha TRUNCADA e a lista inteira era substituída por uma fatia
    // menor que o já carregado, devolvendo a contagem pra trás ~3s depois
    // de cada clique (o próximo poll). Busca só a 1ª página, sempre do
    // mesmo tamanho fixo, e MESCLA no que já está carregado: atualiza/
    // reordena quem apareceu nela (ex: conversa recebeu mensagem nova,
    // subiu pro topo) e preserva intocado tudo que o usuário carregou além
    // da página 1 via "Carregar mais".
    const pegar_conversas_poll = async () => {
        if (!appId) return;

        try {
            const teamQuery = selectedTeamFilter ? `&team=${selectedTeamFilter}` : '';
            const assignQuery = assignQueryValue ? `&assign=${assignQueryValue}` : '';
            const resSummary = await api.get(
                `v1/apps/${appId}/conversations/summary/${selectedTeamFilter ? `?team=${selectedTeamFilter}` : ''}`
            );
            const counts = resSummary.data?.counts || {};
            setConvMeta((prev) => {
                const atualizado = { ...prev };
                STATE_TABS.forEach((state) => {
                    atualizado[state] = {
                        ...(atualizado[state] || {}),
                        total: counts[state]?.total || 0,
                        unread: counts[state]?.unread || 0
                    };
                });
                return atualizado;
            });

            const activeState = STATE_TABS[value];
            const resList = await api.get(
                `v1/apps/${appId}/conversations/?state=${activeState}&limit=${PAGE_SIZE}&offset=0${teamQuery}${assignQuery}`
            );
            const pagina1 = resList.data?.conversations || [];
            const idsPagina1 = new Set(pagina1.map((c) => c.id));

            setConversationsByState((prev) => {
                const restante = (prev[activeState] || []).filter((c) => !idsPagina1.has(c.id));
                const atualizado = { ...prev, [activeState]: [...pagina1, ...restante] };
                convLoadedCountRef.current = { ...convLoadedCountRef.current, [activeState]: atualizado[activeState].length };
                return atualizado;
            });

            if (typeof resList.data?.total === 'number') {
                setConvMeta((prev) => ({ ...prev, [activeState]: { ...(prev[activeState] || {}), total: resList.data.total } }));
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleLoadMoreConversas = async () => {
        if (!appId) return;
        const activeState = STATE_TABS[value];
        const jaCarregadas = conversationsByState[activeState]?.length || 0;

        setConvMeta((prev) => ({ ...prev, [activeState]: { ...(prev[activeState] || {}), loadingMore: true } }));

        try {
            const teamQuery = selectedTeamFilter ? `&team=${selectedTeamFilter}` : '';
            const assignQuery = assignQueryValue ? `&assign=${assignQueryValue}` : '';
            const res = await api.get(
                `v1/apps/${appId}/conversations/?state=${activeState}&limit=${PAGE_SIZE}&offset=${jaCarregadas}${teamQuery}${assignQuery}`
            );
            const novas = res.data?.conversations || [];
            const idsExistentes = new Set((conversationsByState[activeState] || []).map((c) => c.id));
            const semDuplicadas = novas.filter((c) => !idsExistentes.has(c.id));

            setConversationsByState((prev) => {
                const atualizado = { ...prev, [activeState]: [...(prev[activeState] || []), ...semDuplicadas] };
                convLoadedCountRef.current = { ...convLoadedCountRef.current, [activeState]: atualizado[activeState].length };
                return atualizado;
            });
            setConvMeta((prev) => ({
                ...prev,
                [activeState]: { ...(prev[activeState] || {}), total: res.data?.total ?? prev[activeState]?.total ?? 0, loadingMore: false }
            }));
        } catch (error) {
            console.error(error);
            setConvMeta((prev) => ({ ...prev, [activeState]: { ...(prev[activeState] || {}), loadingMore: false } }));
        }
    };

    // Mescla a janela mais recente (`incoming`, sempre em ordem crescente)
    // nas mensagens já carregadas - sem isso, o poll de 3s (que só busca a
    // janela mais recente desde a paginação no backend) apagaria qualquer
    // página mais antiga já trazida via "Carregar mensagens anteriores".
    // Mensagens já presentes são atualizadas (ex: tique de status) sem
    // mudar de posição; as que não estavam ainda são anexadas no fim.
    const mergeIncomingMessages = (prevMessages, incoming) => {
        if (prevMessages.length === 0) return incoming;
        const incomingById = new Map(incoming.map((m) => [m.id, m]));
        const mescladas = prevMessages.map((m) => incomingById.get(m.id) || m);
        const idsExistentes = new Set(prevMessages.map((m) => m.id));
        const novas = incoming.filter((m) => !idsExistentes.has(m.id));
        return [...mescladas, ...novas];
    };

    const pegar_mensagens_conversa = async ({ merge = false } = {}) => {
        try {
            if (!appId) return;
            // console.log(`Mensagens da conversa ${selectedConversation.id}`);
            if (selectedConversation) {
                const conversationIdNoMomentoDaRequisicao = selectedConversation.id;
                const response = await api.get(`v1/apps/${appId}/conversations/${conversationIdNoMomentoDaRequisicao}/messages/`);

                // Se o usuário já trocou de conversa enquanto essa requisição
                // estava em andamento, descarta a resposta - senão as mensagens
                // da conversa antiga podem chegar depois e sobrescrever as da
                // conversa nova que já foi aberta.
                if (conversationIdNoMomentoDaRequisicao !== selectedConversationIdRef.current) {
                    return;
                }

                if (response.data) {
                    // console.log(`Mensagens: ${JSON.stringify(response.data.messages.length)}`);
                    if (merge) {
                        setMessages((prev) => mergeIncomingMessages(prev, response.data.messages));
                    } else {
                        setMessages(response.data.messages);
                        setHasMoreOlderMessages(Boolean(response.data.has_more_older));
                    }
                } else {
                    // setStatus({
                    //     type: 'error',
                    //     message: 'Erro ao pegar as mensagens da conversa.'
                    // });
                    console.log('Erro ao pegar as mensagens da conversa.');
                }

                if (conversationIdNoMomentoDaRequisicao === selectedConversationIdRef.current) {
                    setMessagesLoading(false);
                }
            }
        } catch (error) {
            console.error(error);
            // setStatus({
            //     type: 'error',
            //     message: 'Erro ao pegar as mensagens da conversa.'
            // });
            console.log('Erro ao pegar as mensagens da conversa.');
            setMessagesLoading(false);
        }
    };

    // Busca a página de mensagens imediatamente anterior à mais antiga já
    // carregada ("Carregar mensagens anteriores", exibido no topo da
    // lista quando `has_more_older` vem `true`) e PREPENDA no array - não
    // mexe nas mensagens já visíveis, só estende a janela pra trás.
    const loadOlderMessages = async () => {
        if (!appId || !selectedConversation || messages.length === 0 || loadingOlderMessages) return;
        setLoadingOlderMessages(true);
        try {
            const conversationIdNoMomentoDaRequisicao = selectedConversation.id;
            const maisAntigaCarregadaId = messages[0].id;
            const response = await api.get(
                `v1/apps/${appId}/conversations/${conversationIdNoMomentoDaRequisicao}/messages/?before_id=${maisAntigaCarregadaId}`
            );

            if (conversationIdNoMomentoDaRequisicao !== selectedConversationIdRef.current) {
                return;
            }

            if (response.data) {
                setMessages((prev) => [...response.data.messages, ...prev]);
                setHasMoreOlderMessages(Boolean(response.data.has_more_older));
            }
        } catch (error) {
            console.error('Erro ao carregar mensagens anteriores', error);
        } finally {
            setLoadingOlderMessages(false);
        }
    };

    const marcar_conversa_como_lida = async (conversation) => {
        if (!appId) return;
        if (!integration_id) return;
        if (!conversation) return;

        console.log(`marcar_conversa_como_lida - entrou`);
        try {
            // console.log(`marcar_conversa_como_lida: entrou`);
            // console.log(`marcar_conversa_como_lida conversation: ${conversation}`);
            if (!conversation) return;
            const response = await api.patch(`v1/apps/${appId}/conversations/${conversation.id}/`, {
                read: true
            });
            if (response.data) {
                console.log(`marcar_conversa_como_lida - response.data:${JSON.stringify(response.data)}`);
                marcar_mensagens_como_lida(conversation);
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao marcar conversa como lida'
                });
            }
        } catch (error) {
            console.error(error);
            setStatus({
                type: 'error',
                message: 'Erro ao marcar conversa como lida'
            });
        }
    };

    const marcar_mensagens_como_lida = async (conversation) => {
        try {
            if (!appId) return;
            if (!conversation) return;
            if (!integration_id) return;
            console.log(`marcar_mensagens_como_lida: entrou`);

            const response = await api.patch(`v1/apps/${appId}/conversations/${conversation.id}/messages/`, {
                read: true
            });
            if (response.data) {
                console.log(`marcar_mensagens_como_lida - response.data:${JSON.stringify(response.data)}`);
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao marcar conversa como lida'
                });
            }
        } catch (error) {
            console.error(error);
            setStatus({
                type: 'error',
                message: 'Erro ao marcar conversa como lida'
            });
        }
    };

    const enviar_mensagens_conversa = async () => {
        try {
            if (!appId) return;
            // console.log(`enviar_mensagens_conversa: ${inputMessage}`);

            const response = await api.post(`v1/apps/${appId}/conversations/${selectedConversation.id}/messages/`, {
                author: {
                    userId: '',
                    avatarUrl: '',
                    displayName: 'Nome Atendente',
                    type: 'agent'
                },
                content: {
                    type: 'text',
                    text: inputMessage
                },
                source: {
                    integrationId: '1',
                    originalMessageId: '',
                    originalMessageTimestamp: '',
                    type: 'text'
                }
            });
            if (response.data) {
                setInputMessage('');
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao enviar mensagem na conversa!'
                });
            }
        } catch (error) {
            console.error(error);
            setStatus({
                type: 'error',
                message: 'Erro ao enviar mensagem na conversa!'
            });
        }
    };

    const handleOpenConversation = async (conversation, deal) => {
        console.log(`handleOpenConversation - conversation:${JSON.stringify(conversation)}`);
        console.log(`handleOpenConversation - deal:${JSON.stringify(deal)}`);

        // Limpa a conversa/mensagens antigas JÁ, antes de qualquer busca
        // assíncrona - sem isso, o chat continua mostrando a conversa
        // anterior por alguns segundos até a mensagens da nova chegarem.
        selectedConversationIdRef.current = conversation?.id || null;
        setMessages([]);
        setHasMoreOlderMessages(false);
        setMessagesLoading(true);
        setSelectedConversation(conversation);
        setDrawerOpen(true);
        setIntegrationId(conversation.integration);
        updateViewingConversation(appId, conversation?.id);

        if (!deal && conversation?.deal) {
            // vindo da lista normal de conversas (não do kanban): o negócio ativo
            // só é conhecido pelo id, precisa buscar os dados completos
            try {
                const response = await api.get(`deals/${conversation.deal}/`);
                setSelectedDeal(response.data);
            } catch (error) {
                console.error(error);
                setSelectedDeal(null);
            }
        } else {
            setSelectedDeal(deal);
        }

        if (!conversation) return;
        marcar_conversa_como_lida(conversation);
    };

    const handleToggleSelectionMode = () => {
        setSelectionMode((prev) => !prev);
        setSelectedConversationIds(new Set());
    };

    const handleToggleSelectConversation = (conversationId) => {
        setSelectedConversationIds((prev) => {
            const next = new Set(prev);
            if (next.has(conversationId)) {
                next.delete(conversationId);
            } else {
                next.add(conversationId);
            }
            return next;
        });
    };

    // "Selecionar todas" marca/desmarca só as conversas JÁ carregadas na
    // aba atual (`visibleConversations` - mesma lista renderizada) - com
    // centenas de conversas paginadas (`PAGE_SIZE`), cobre tudo que já foi
    // trazido com "Carregar mais"; o usuário repete a ação a cada lote novo.
    const handleToggleSelectAll = (visibleConversations) => {
        const visibleIds = visibleConversations.map((c) => c.id);
        const allSelected = visibleIds.length > 0 && visibleIds.every((id) => selectedConversationIds.has(id));
        setSelectedConversationIds((prev) => {
            const next = new Set(prev);
            if (allSelected) {
                visibleIds.forEach((id) => next.delete(id));
            } else {
                visibleIds.forEach((id) => next.add(id));
            }
            return next;
        });
    };

    const handleBulkCloseConversations = async () => {
        const ids = Array.from(selectedConversationIds);
        setActionsMenuAnchor(null);
        if (ids.length === 0) return;
        if (!window.confirm(`Finalizar ${ids.length} conversa(s) selecionada(s)? Essa ação não pode ser desfeita.`)) return;

        setBulkActionLoading(true);
        try {
            await api.post(`v1/apps/${appId}/conversations/bulk_close/`, { conversation_ids: ids });

            // Some da listagem atual na hora, sem esperar o próximo
            // refresh/poll - o fechamento em si roda em background (ver
            // endpoint), mas pro usuário a conversa já deixou de estar
            // "em andamento" assim que ele mandou a ação.
            const idsSet = new Set(ids);
            setConversationsByState((prev) => {
                const next = {};
                for (const state of Object.keys(prev)) {
                    next[state] = (prev[state] || []).filter((c) => !idsSet.has(c.id));
                }
                return next;
            });
            setStatus({ type: 'success', message: `${ids.length} conversa(s) finalizada(s).` });
            setSelectedConversationIds(new Set());
            setSelectionMode(false);
        } catch (error) {
            console.error('Erro ao finalizar conversas em lote', error);
            setStatus({ type: 'error', message: 'Erro ao finalizar conversas selecionadas.' });
        } finally {
            setBulkActionLoading(false);
        }
    };

    const handleCloseDrawer = () => {
        selectedConversationIdRef.current = null;
        setDrawerOpen(false);
        setSelectedConversation(null);
        setMessages([]);
        setHasMoreOlderMessages(false);
        setMessagesLoading(false);
        updateViewingConversation(appId, null);
    };

    const handleChange = (e) => {
        console.log(`handleChange: ${e.target}`);
        const { name, value } = e.target;
        setInputMessage(value);
        console.log(`inputMessage: ${inputMessage}`);
    };

    //? TEMA DO INPUT MENSAGEM
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const [showEmoji, setShowEmoji] = useState(false);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (inputMessage.trim()) {
                enviar_mensagens_conversa();
                setInputMessage('');
            }
        }
    };

    //? -------------- FUNCOES NEGOCIO ------------------------
    // pegar_negocios() foi removida - era um polling de 3s duplicado,
    // buscando os mesmos deals que loadPipeline() já busca (e guardava
    // num estado `negocio` que nada no componente lia).

    const fonteStyle1 = {
        fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
        fontSize: 15,
        lineHeight: 0.8,
        color: 'black'
    };

    const fonteStyle2 = {
        fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
        fontSize: 12,
        lineHeight: 0.8,
        color: 'black'
    };

    const fonteStyle3 = {
        fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
        fontSize: 10,
        lineHeight: 0.1,
        color: 'black'
    };

    useEffect(() => {
        if (!appId) return;
        loadPipeline();
    }, []);

    async function loadPipeline() {
        if (!appId) return;

        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        try {
            var stagesList;
            const response = await api.get(`v1/apps/${appId}/pipelines/`);
            if (!response.data) return;

            if (response.data.length === 0) {
                setStatus({
                    type: 'error',
                    message: 'ERRO! NÃO EXISTEM PIPELINES CADASTRADAS! VÁ PARA "CONFIGURAÇÕES > NEGÓCIO" PARA CRIAR!'
                });
                return;
            }

            const dados = response.data;
            var resPipelines = dados;
            setPipelines(resPipelines);
            let pipelineId = resPipelines[0].id;
            setPipelineId(pipelineId);

            // console.log(`loadPipeline - pipelineId:${pipelineId}`);

            const myHeaders2 = new Headers();
            myHeaders2.append('Content-Type', 'application/json');

            const response3 = await api.get(`v1/apps/${appId}/pipelines/${pipelineId}/stages/`);

            if (response3.data.length === 0) {
                setStatus({
                    type: 'error',
                    message: 'ERRO! NÃO EXISTEM STAGES CADASTRADAS! VÁ PARA "CONFIGURAÇÕES > NEGÓCIO > FASES" PARA CRIAR!'
                });
                return;
            }

            const dados3 = response3.data;

            var resStages = dados3;

            // console.log(`loadPipeline - resStages:${resStages}`);

            stagesList = resStages;
            if (!stagesList) {
                stagesList = [];
            }

            // console.log(`loadPipeline - stagesList:${stagesList}`);
            setStages(stagesList);

            const myHeaders4 = new Headers();
            myHeaders4.append('Content-Type', 'application/json');
            if (!pipelineId) return;
            const response4 = await api.get(`v1/apps/${appId}/pipelines/${pipelineId}/deals/`);
            if (!response4.data) return;

            // if (response4.data.length === 0) {
            //     setStatus({
            //         type: 'error',
            //         message: 'Ainda não existem negócios criados!'
            //     });
            // }

            const dados4 = response4.data;
            // console.log('loadPipeline - dados4:', dados4);

            var resDeals = dados4;
            const deals = resDeals;

            // console.log(`loadPipeline - deals:${deals}`);

            const map = {};
            stagesList.forEach((s) => (map[s.id] = []));
            if (!deals) return;
            deals.forEach((d) => {
                const sid = d.stage || (stagesList[0] && stagesList[0].id);
                if (!map[sid]) map[sid] = [];
                map[sid].push(d);
            });

            // ordenar localmente por order
            Object.keys(map).forEach((k) => map[k].sort((a, b) => a.order - b.order));

            // console.log(`dealsByStage 1: ${JSON.stringify(map)}`);
            setDealsByStage(map);
            // console.log(`dealsByStage 2: ${JSON.stringify(dealsByStage)}`);

            // const response5 = await api.get(`stages/?pipeline=${pipelineId}`);
            // if (!response5.data) return;

            // if (response5.data) {
            //     setStages(response5.data);
            // }

            // if (response5.data.length === 0) {
            //     setStatus({
            //         type: 'error',
            //         message: 'Ainda não existem stages criados!'
            //     });
            // }
        } catch (err) {
            // setStatus({
            //     type: 'error',
            //     message: 'ERRO AO CONSULTAR NEGÓCIOS'
            // });
            console.log(`loadPipeline - err: ${err}`);
        }
    }

    const onDragEnd = async (result) => {
        const { destination, source, draggableId } = result;
        if (!destination) return;

        const fromStage = parseInt(source.droppableId);
        const toStage = parseInt(destination.droppableId);

        // Se nada mudou, não faz nada
        if (fromStage === toStage && source.index === destination.index) {
            return;
        }

        let newMap = { ...dealsByStage };

        // Movendo DENTRO da mesma coluna
        if (fromStage === toStage) {
            const items = Array.from(newMap[fromStage]);
            const [moved] = items.splice(source.index, 1);
            items.splice(destination.index, 0, moved);

            newMap[fromStage] = items;
        }
        // Movendo ENTRE colunas
        else {
            const sourceItems = Array.from(newMap[fromStage]);
            const destItems = Array.from(newMap[toStage]);
            const [moved] = sourceItems.splice(source.index, 1);

            moved.stage = toStage; // atualiza stage localmente

            destItems.splice(destination.index, 0, moved);

            newMap[fromStage] = sourceItems;
            newMap[toStage] = destItems;
        }

        console.log(`setDealsByStage newMap: ${JSON.stringify(newMap)}`);
        setDealsByStage(newMap);

        // Agora envia o payload correto ao backend
        const payload = [];
        Object.keys(newMap).forEach((stageId) => {
            newMap[stageId].forEach((d, idx) => {
                payload.push({
                    id: d.id,
                    stage: parseInt(stageId),
                    order: idx
                });
            });
        });

        try {
            const myHeaders5 = new Headers();
            myHeaders5.append('Content-Type', 'application/json');
            const response5 = await api.post(`v1/apps/${appId}/deals/reorder/`, payload);
            if (response5.data) {
                const dados5 = response5.data;
                console.log('onDrag - dados5:', dados5);
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao reordenar Negócios!'
                });
            }
        } catch (err) {
            console.error(err);
            loadPipeline();
            setStatus({
                type: 'error',
                message: 'Erro ao reordenar Negócios!'
            });
        }
    };

    // const openDeal = (deal) => {
    //     setSelectedDeal(deal);
    //     setOpenDrawer(true);
    // };

    // const handleNameUser = () => {};
    // useEffect(() => {});

    // console.log(`USERRRRR: ${JSON.stringify(user)}`);
    // console.log(`qtdConvNew: ${qtdConvNew}`);

    // Obtém a hora atual de São Paulo como um número inteiro
    const horaSp = parseInt(
        new Intl.DateTimeFormat('pt-BR', {
            timeZone: 'America/Sao_Paulo',
            hour: '2-digit',
            hour12: false
        }).format(new Date()),
        10
    );

    // Validação da saudação
    let saudacao = '';

    if (horaSp >= 5 && horaSp < 12) {
        saudacao = 'Bom dia, ';
    } else if (horaSp >= 12 && horaSp < 18) {
        saudacao = 'Boa tarde, ';
    } else {
        saudacao = 'Boa noite, ';
    }

    // Conjunto de conversas "visíveis" no momento, pra alimentar o
    // checkbox "Selecionar todas" - varia conforme a visão atual (lista
    // personalizada / busca global / aba de status), já que são listas
    // diferentes renderizadas abaixo.
    const visibleConversationsForSelection = selectedListId
        ? listConversations
        : buscaGlobalResultados !== null
        ? filtrarConversas(buscaGlobalResultados)
        : filtrarConversas(conversationsByState[STATE_TABS[value]]);
    const visibleSelectionIds = visibleConversationsForSelection.map((c) => c.id);
    const allVisibleSelected = visibleSelectionIds.length > 0 && visibleSelectionIds.every((id) => selectedConversationIds.has(id));
    const someVisibleSelected = visibleSelectionIds.some((id) => selectedConversationIds.has(id));

    return (
        <Box
            sx={{
                minHeight: '100vh',
                px: 2,
                py: 3,
                background: isDark
                    ? `
                    radial-gradient(circle at 52% 8%, rgba(0,183,255,0.12), transparent 18%),
                    radial-gradient(circle at 10% 88%, rgba(0,120,255,0.10), transparent 18%),
                    linear-gradient(180deg, #03070d 0%, #050c15 45%, #02050a 100%)
                `
                    : `
                    radial-gradient(circle at 52% 8%, rgba(0,150,255,0.08), transparent 18%),
                    radial-gradient(circle at 10% 88%, rgba(0,120,255,0.06), transparent 18%),
                    linear-gradient(180deg, #f4faff 0%, #e8f4ff 45%, #f4faff 100%)
                `
            }}
        >
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: 500,
                        color: isDark ? 'rgba(255,255,255,0.95)' : 'rgba(8,35,60,0.92)'
                    }}
                >
                    {saudacao} {user?.first_name || user?.email}
                </Typography>

                <Box display="flex" gap={1}>
                    {pushPermission === 'default' && (
                        <Button variant="outlined" startIcon={<IconBell size={18} />} onClick={handleAtivarNotificacoes}>
                            Ativar notificações
                        </Button>
                    )}

                    <Button variant="contained" startIcon={<IconPlus size={18} />} onClick={() => setOpenNovaConversa(true)}>
                        Nova conversa
                    </Button>
                </Box>
            </Box>

            <NovaConversaDialog
                open={openNovaConversa}
                onClose={() => setOpenNovaConversa(false)}
                appId={appId}
                onCreated={(conversation) => {
                    handleOpenConversation(conversation);
                    pegar_conversas();
                    loadPipeline();
                }}
            />

            {status.message && (
                <Alert
                    severity={status.type}
                    sx={{
                        mt: 2,
                        mb: 2,
                        borderRadius: '18px',
                        background: isDark ? 'rgba(14,26,42,0.88)' : 'rgba(255,255,255,0.9)',
                        color: isDark ? '#fff' : 'rgba(8,35,60,0.92)',
                        border: isDark ? '1px solid rgba(110,220,255,0.12)' : '1px solid rgba(0,120,220,0.15)'
                    }}
                >
                    {status.message}
                </Alert>
            )}

            {/* <Box display="flex" gap={0.3} sx={{ p: 1, mt: 1, ml: -3 }}>
                <DragDropContext onDragEnd={onDragEnd}>
                    {stages.map((stage) => (
                        <Droppable droppableId={`${stage.id}`} key={stage.id}>
                            {(provided) => (
                                <Box ref={provided.innerRef} {...provided.droppableProps} sx={{ minWidth: 200, maxWidth: 230 }}>
                                    <Box mb={1} display="flex" justifyContent="flex" alignItems="center">
                                        <Typography variant="h4" justifyContent="center" marginLeft={8} style={fonteStyle1}>
                                            {stage.name}
                                        </Typography>
                                    </Box>
                                    <Box mb={1} display="flex" justifyContent="flex" alignItems="center">
                                        {(() => {
                                            const total = (dealsByStage[stage.id] || []).reduce(
                                                (acc, deal) => acc + parseFloat(deal.value || 0),
                                                0
                                            );

                                            return (
                                                <>
                                                    <Typography variant="5px" justifyContent="center" marginLeft={10} style={fonteStyle2}>
                                                        R${total.toFixed(2)}
                                                    </Typography>
                                                </>
                                            );
                                        })()}
                                    </Box>
                                    <Box>
                                        <Typography
                                            variant="5px"
                                            color="textSecondary"
                                            justifyContent="center"
                                            marginLeft={10}
                                            style={fonteStyle3}
                                        >
                                            {(dealsByStage[stage.id] || []).length}{' '}
                                            {(dealsByStage[stage.id] || []).length > 1 ? 'negócios' : 'negócio'}
                                        </Typography>
                                    </Box>

                                    <Card
                                        variant="outlined"
                                        sx={{ minWidth: 220, minHeight: 500, marginLeft: 0.0, marginRight: 0.0, background: '#262525' }}
                                    >
                                        <CardContent>
                                            {(dealsByStage[stage.id] || []).map((deal, index) => (
                                                <Draggable draggableId={`${deal.id}`} index={index} key={deal.id}>
                                                    {(provided2, snapshot) => (
                                                        <div
                                                            ref={provided2.innerRef}
                                                            {...provided2.draggableProps}
                                                            {...provided2.dragHandleProps}
                                                            style={{
                                                                userSelect: 'none',
                                                                marginBottom: 0,
                                                                marginLeft: 0,
                                                                marginRight: 0,
                                                                ...provided2.draggableProps.style
                                                            }}
                                                        >
                                                            <DealConversationCard
                                                                deal={deal}
                                                                onClick={() => handleOpenConversation(deal.conversation, deal)}
                                                            />
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </CardContent>
                                    </Card>
                                </Box>
                            )}
                        </Droppable>
                    ))}
                </DragDropContext>
            </Box> */}

            <Box sx={{ mt: 3 }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Button
                        variant="outlined"
                        startIcon={<IconFilter size={18} />}
                        onClick={() => setShowFilters((prev) => !prev)}
                        sx={{ borderRadius: '14px', textTransform: 'none' }}
                    >
                        <Badge badgeContent={filtrosAtivosCount} color="primary" sx={{ '& .MuiBadge-badge': { right: -10 } }}>
                            Filtros
                        </Badge>
                    </Button>

                    {filtrosAtivosCount > 0 && (
                        <Button
                            variant="text"
                            startIcon={<IconFilterOff size={18} />}
                            onClick={limparFiltros}
                            sx={{ textTransform: 'none' }}
                        >
                            Limpar filtros
                        </Button>
                    )}

                    <Button
                        variant="outlined"
                        startIcon={<IconUsers size={18} />}
                        onClick={(e) => setTeamMenuAnchor(e.currentTarget)}
                        sx={{ borderRadius: '14px', textTransform: 'none' }}
                    >
                        {selectedTeamFilter
                            ? `Equipe: ${equipesFiltro.find((eq) => eq.id === selectedTeamFilter)?.name || '...'}`
                            : 'Equipes'}
                    </Button>

                    <Menu anchorEl={teamMenuAnchor} open={!!teamMenuAnchor} onClose={() => setTeamMenuAnchor(null)}>
                        <MenuItem selected={!selectedTeamFilter} onClick={() => handleSelectTeamFilter('')}>
                            Todas
                        </MenuItem>
                        {equipesFiltro.length === 0 && <MenuItem disabled>Nenhuma equipe disponível</MenuItem>}
                        {equipesFiltro.map((eq) => (
                            <MenuItem key={eq.id} selected={selectedTeamFilter === eq.id} onClick={() => handleSelectTeamFilter(eq.id)}>
                                {eq.name}
                            </MenuItem>
                        ))}
                    </Menu>
                </Box>

                <Collapse in={showFilters}>
                    <Box sx={getFilterPanelSx(isDark)}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    label="Canal de mensagem"
                                    value={filtros.canal}
                                    onChange={(e) => setFiltros({ ...filtros, canal: e.target.value })}
                                    sx={getFilterFieldSx(isDark)}
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    {CANAIS_MENSAGEM.map((c) => (
                                        <MenuItem key={c.value} value={c.value}>
                                            {c.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="date"
                                    label="Criada a partir de"
                                    InputLabelProps={{ shrink: true }}
                                    value={filtros.dataInicio}
                                    onChange={(e) => setFiltros({ ...filtros, dataInicio: e.target.value })}
                                    sx={getFilterFieldSx(isDark)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="date"
                                    label="Criada até"
                                    InputLabelProps={{ shrink: true }}
                                    value={filtros.dataFim}
                                    onChange={(e) => setFiltros({ ...filtros, dataFim: e.target.value })}
                                    sx={getFilterFieldSx(isDark)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={filtros.apenasMeus}
                                            onChange={(e) => setFiltros({ ...filtros, apenasMeus: e.target.checked })}
                                        />
                                    }
                                    label="Atribuídos a mim"
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={filtros.naoAbertos}
                                            onChange={(e) => setFiltros({ ...filtros, naoAbertos: e.target.checked })}
                                        />
                                    }
                                    label="Não abertos (última mensagem do cliente)"
                                />
                            </Grid>

                            {podeFiltrarPorQualquerAtribuido && (
                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Atribuído"
                                        value={filtros.assign}
                                        onChange={(e) => setFiltros({ ...filtros, assign: e.target.value })}
                                        sx={getFilterFieldSx(isDark)}
                                    >
                                        <MenuItem value="">Todos</MenuItem>
                                        {teamUsers.map((u) => (
                                            <MenuItem key={u.id} value={u.id}>
                                                {u.first_name} {u.last_name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            )}

                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Nome do contato (canal)"
                                    value={filtros.contatoCanal}
                                    onChange={(e) => setFiltros({ ...filtros, contatoCanal: e.target.value })}
                                    sx={getFilterFieldSx(isDark)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Nome do cliente cadastrado"
                                    value={filtros.nomeCliente}
                                    onChange={(e) => setFiltros({ ...filtros, nomeCliente: e.target.value })}
                                    sx={getFilterFieldSx(isDark)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Organização"
                                    value={filtros.nomeOrganizacao}
                                    onChange={(e) => setFiltros({ ...filtros, nomeOrganizacao: e.target.value })}
                                    sx={getFilterFieldSx(isDark)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Buscar por palavra na conversa"
                                    placeholder="Ex: orçamento, contrato..."
                                    value={filtros.textoMensagem}
                                    onChange={(e) => setFiltros({ ...filtros, textoMensagem: e.target.value })}
                                    sx={getFilterFieldSx(isDark)}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Collapse>
            </Box>

            <Box sx={getBoardContainerSx(isDark)}>
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        pointerEvents: 'none',
                        borderRadius: '30px',
                        boxShadow: isDark
                            ? 'inset 0 0 120px rgba(0,170,255,0.05), inset 0 0 1px rgba(130,235,255,0.30)'
                            : 'inset 0 0 80px rgba(0,140,255,0.04), inset 0 0 1px rgba(0,140,255,0.20)'
                    }}
                />

                {/* LISTAS PERSONALIZADAS (etiquetas) - independente das abas de status abaixo */}
                <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" sx={{ px: 2, pt: 1.5, pb: selectedListId ? 0 : 1 }}>
                    {selectedListId && <Chip label="← Voltar" size="small" variant="outlined" onClick={handleClearSelectedList} />}
                    {customLists.map((lst) => (
                        <Chip
                            key={lst.id}
                            label={lst.name}
                            size="small"
                            onClick={() => handleSelectList(lst.id)}
                            onDelete={() => handleDeleteList(lst.id, lst.name)}
                            variant={selectedListId === lst.id ? 'filled' : 'outlined'}
                            sx={{
                                backgroundColor: selectedListId === lst.id ? lst.color || undefined : undefined,
                                borderColor: lst.color || undefined,
                                color: selectedListId === lst.id ? '#fff' : undefined
                            }}
                        />
                    ))}
                    <Chip label="+ Nova lista" size="small" variant="outlined" onClick={() => setCreateListDialogOpen(true)} />
                </Box>

                {/* SELEÇÃO EM LOTE - checkbox por conversa + "Ações" (ex: Finalizar
                    várias de uma vez, útil depois de um disparo pra centenas de
                    clientes) */}
                <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap" sx={{ px: 2, pb: 1 }}>
                    <Button
                        size="small"
                        variant={selectionMode ? 'contained' : 'outlined'}
                        onClick={handleToggleSelectionMode}
                    >
                        {selectionMode ? 'Cancelar seleção' : 'Selecionar conversas'}
                    </Button>

                    {selectionMode && (
                        <>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={allVisibleSelected}
                                        indeterminate={someVisibleSelected && !allVisibleSelected}
                                        onChange={() => handleToggleSelectAll(visibleConversationsForSelection)}
                                    />
                                }
                                label="Selecionar todas"
                            />

                            <Typography variant="body2" color="text.secondary">
                                {selectedConversationIds.size} selecionada(s)
                            </Typography>

                            <Button
                                size="small"
                                variant="outlined"
                                disabled={selectedConversationIds.size === 0 || bulkActionLoading}
                                onClick={(e) => setActionsMenuAnchor(e.currentTarget)}
                            >
                                Ações
                            </Button>
                            <Menu anchorEl={actionsMenuAnchor} open={!!actionsMenuAnchor} onClose={() => setActionsMenuAnchor(null)}>
                                <MenuItem onClick={handleBulkCloseConversations}>Finalizar conversas selecionadas</MenuItem>
                            </Menu>
                        </>
                    )}
                </Box>

                {selectedListId ? (
                    <Box sx={{ px: 2, pb: 2, mt: 4 }}>
                        <ConversasGeral
                            conversas={listConversations}
                            onOpenConversation={handleOpenConversation}
                            selectionMode={selectionMode}
                            selectedIds={selectedConversationIds}
                            onToggleSelect={handleToggleSelectConversation}
                        />
                    </Box>
                ) : buscaGlobalResultados !== null ? (
                    <Box sx={{ px: 2, pb: 2, mt: 2 }}>
                        {buscaGlobalLoading && <LinearProgress sx={{ mb: 1.5, borderRadius: '4px' }} />}
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            {buscaGlobalResultados.length} conversa(s) encontrada(s) em todas as etapas
                        </Typography>
                        <ConversasGeral
                            conversas={filtrarConversas(buscaGlobalResultados)}
                            onOpenConversation={handleOpenConversation}
                            showState
                            selectionMode={selectionMode}
                            selectedIds={selectedConversationIds}
                            onToggleSelect={handleToggleSelectConversation}
                        />
                    </Box>
                ) : (
                    <>
                        <StyledTabs
                            isDark={isDark}
                            value={value}
                            onChange={(e, v) => setValue(v)}
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                        >
                            <StyledTab
                                isDark={isDark}
                                label={
                                    <Badge badgeContent={convMeta.in_bot?.unread || 0} color="secondary">
                                        <Typography variant="body2" color="text.primary">
                                            No Bot
                                        </Typography>
                                    </Badge>
                                }
                                {...a11yProps(0)}
                            />

                            <StyledTab
                                isDark={isDark}
                                label={
                                    <Badge badgeContent={convMeta.new?.unread || 0} color="secondary">
                                        <Typography variant="body2" color="text.primary">
                                            Novas
                                        </Typography>
                                    </Badge>
                                }
                                {...a11yProps(0)}
                            />

                            <StyledTab
                                isDark={isDark}
                                color="textPrimary"
                                label={
                                    <Badge badgeContent={convMeta.open?.unread || 0} color="secondary">
                                        <Typography variant="body2" color="text.primary">
                                            Abertas
                                        </Typography>
                                    </Badge>
                                }
                                {...a11yProps(1)}
                            />
                            <StyledTab
                                isDark={isDark}
                                color="textPrimary"
                                label={
                                    <Badge badgeContent={convMeta.in_progress?.unread || 0} color="secondary">
                                        <Typography variant="body2" color="text.primary">
                                            Em andamento
                                        </Typography>
                                    </Badge>
                                }
                                {...a11yProps(2)}
                            />
                            <StyledTab
                                isDark={isDark}
                                color="textPrimary"
                                label={
                                    <Badge badgeContent={convMeta.pending?.unread || 0} color="secondary">
                                        <Typography variant="body2" color="text.primary">
                                            Pendente
                                        </Typography>
                                    </Badge>
                                }
                                {...a11yProps(3)}
                            />
                            <StyledTab
                                isDark={isDark}
                                color="textPrimary"
                                label={
                                    <Badge badgeContent={convMeta.closed?.unread || 0} color="secondary">
                                        <Typography variant="body2" color="text.primary">
                                            Fechada
                                        </Typography>
                                    </Badge>
                                }
                                {...a11yProps(4)}
                            />
                        </StyledTabs>

                        {/* NO BOT */}
                        <TabPanel value={value} index={0}>
                            <ConversasGeral
                                conversas={filtrarConversas(conversationsByState.in_bot)}
                                onOpenConversation={handleOpenConversation}
                                selectionMode={selectionMode}
                                selectedIds={selectedConversationIds}
                                onToggleSelect={handleToggleSelectConversation}
                            />
                            {renderCarregarMaisConversas('in_bot')}
                        </TabPanel>

                        {/* NOVAS */}
                        <TabPanel value={value} index={1}>
                            <ConversasGeral
                                conversas={filtrarConversas(conversationsByState.new)}
                                onOpenConversation={handleOpenConversation}
                                selectionMode={selectionMode}
                                selectedIds={selectedConversationIds}
                                onToggleSelect={handleToggleSelectConversation}
                            />
                            {renderCarregarMaisConversas('new')}
                        </TabPanel>

                        {/* ABERTAS */}
                        <TabPanel value={value} index={2}>
                            <ConversasGeral
                                conversas={filtrarConversas(conversationsByState.open)}
                                onOpenConversation={handleOpenConversation}
                                selectionMode={selectionMode}
                                selectedIds={selectedConversationIds}
                                onToggleSelect={handleToggleSelectConversation}
                            />
                            {renderCarregarMaisConversas('open')}
                        </TabPanel>

                        {/* EM ANDAMENTO */}
                        <TabPanel value={value} index={3}>
                            <ConversasGeral
                                conversas={filtrarConversas(conversationsByState.in_progress)}
                                onOpenConversation={handleOpenConversation}
                                selectionMode={selectionMode}
                                selectedIds={selectedConversationIds}
                                onToggleSelect={handleToggleSelectConversation}
                            />
                            {renderCarregarMaisConversas('in_progress')}
                        </TabPanel>

                        {/* PENDENTE */}
                        <TabPanel value={value} index={4}>
                            <ConversasGeral
                                conversas={filtrarConversas(conversationsByState.pending)}
                                onOpenConversation={handleOpenConversation}
                                selectionMode={selectionMode}
                                selectedIds={selectedConversationIds}
                                onToggleSelect={handleToggleSelectConversation}
                            />
                            {renderCarregarMaisConversas('pending')}
                        </TabPanel>

                        {/* FECHADAS */}
                        <TabPanel value={value} index={5}>
                            <ConversasGeral
                                conversas={filtrarConversas(conversationsByState.closed)}
                                onOpenConversation={handleOpenConversation}
                                selectionMode={selectionMode}
                                selectedIds={selectedConversationIds}
                                onToggleSelect={handleToggleSelectConversation}
                            />
                            {renderCarregarMaisConversas('closed')}
                        </TabPanel>
                    </>
                )}
            </Box>

            {/* CRIAR LISTA PERSONALIZADA */}
            <Dialog open={createListDialogOpen} onClose={() => setCreateListDialogOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Nova lista</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Nome da lista"
                        value={newListName}
                        onChange={(e) => setNewListName(e.target.value)}
                        sx={{ mt: 1, mb: 2 }}
                    />
                    <Typography variant="body2" color="text.secondary" mb={1}>
                        Cor
                    </Typography>
                    <Box display="flex" gap={1}>
                        {['#1976d2', '#2e7d32', '#ed6c02', '#d32f2f', '#7b1fa2', '#455a64'].map((color) => (
                            <Box
                                key={color}
                                onClick={() => setNewListColor(color)}
                                sx={{
                                    width: 28,
                                    height: 28,
                                    borderRadius: '50%',
                                    backgroundColor: color,
                                    cursor: 'pointer',
                                    border: newListColor === color ? '2px solid #000' : '2px solid transparent'
                                }}
                            />
                        ))}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setCreateListDialogOpen(false)}>Cancelar</Button>
                    <Button variant="contained" onClick={handleCreateList} disabled={!newListName.trim()}>
                        Criar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Drawer conversa selecionada */}
            <JanelaConversa
                status_drawer={drawerOpen}
                onCloseDrawer={handleCloseDrawer}
                conversa_selecionada={selectedConversation}
                mensagens={messages}
                carregandoMensagens={messagesLoading}
                appId={appId}
                conversa_lida={marcar_conversa_como_lida}
                deal={selectedDeal}
                onDealChange={setSelectedDeal}
                onDealsChanged={loadPipeline}
                onConversationUpdate={setSelectedConversation}
                pipelineId={pipelineId}
                integration_id={integration_id}
                hasMoreOlderMessages={hasMoreOlderMessages}
                loadingOlderMessages={loadingOlderMessages}
                onLoadOlderMessages={loadOlderMessages}
            />
        </Box>
    );
};

export default Chats;
